import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RoomModel } from 'src/app/models/room.model';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { RoomService } from 'src/app/services/room.service';
import { ToastService } from 'src/app/shared/services/toast.service';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-room',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatButtonModule, MatIconModule],
  templateUrl: './room.component.html',
  styleUrl: './room.component.css'
})
export class RoomComponent implements OnInit {
  rooms: RoomModel[] = [];
  roomForm: FormGroup;
  editingRoom: RoomModel | null = null;

  constructor(private fb: FormBuilder, private roomSrv: RoomService, private toastr: ToastService) {

    this.roomForm = this.fb.group({
      id: [null],
      name: ['', Validators.required],
      description: ['', Validators.required],
      nightPrice: [0, [Validators.required, Validators.min(1)]],
      capacity: [1, [Validators.required, Validators.min(1)]],
      bedsSingle: [0, [Validators.required, Validators.min(0)]],
      bedsDouble: [0, [Validators.required, Validators.min(0)]],
      number: [0, Validators.required],
      observation: [''],
    });
  }

  ngOnInit() {
    this.getRooms()
  }

  getRooms() {
    this.roomSrv.get().subscribe({
      next: (data) => {
        this.rooms = data;
      },
      error: (err) => {
        this.toastr.error(
          'Habitaciones',
          'Error al obtener habitaciones'
        );
      }
    });
  }

  saveRoom() {
    if (this.roomForm.invalid) return;

    const roomData = { ...this.roomForm.value, id: this.editingRoom?.id || 0 };

    const roomNumber = Number(roomData.number);
    const hasDuplicateNumber = this.rooms.some(room => room.number === roomNumber && (!this.editingRoom || room.id !== this.editingRoom.id));

    if (hasDuplicateNumber) {
      this.toastr.error(
        'Habitaciones',
        'Ya existe una habitacion con ese numero'
      );
      return;
    }

    roomData.number = roomNumber;

    if (this.editingRoom) {
      const index = this.rooms.findIndex(r => r.id === this.editingRoom!.id);
      this.roomSrv.put(roomData).subscribe({
        next: (data) => {
          this.rooms[index] = roomData;
          this.toastr.success(
            'Habitaciones',
            'Se ha editado la habitación exitosamente'
          );

        },
        error: (err) => {
          this.toastr.error(
            'Habitaciones',
            'Error al actualizar la información de la habitación'
          );
        }
      });
      this.editingRoom = null;
    } else {
      this.roomSrv.post(roomData).subscribe({
        next: (data) => {
          this.rooms.push(data);
          this.toastr.success(
            'Habitaciones',
            'Se ha guardado la nueva habitación exitosamente'
          );

        },
        error: (err) => {
            this.toastr.error(
              'Habitaciones',
              'Error al guardar la nueva habitación'
            );
        }
      });
    }

    this.roomForm.reset({ nightPrice: 0, capacity: 1, bedsSingle: 0, bedsDouble: 0 });
  }

  editRoom(room: RoomModel) {
    this.editingRoom = room;
    this.roomForm.patchValue(room);
  }

  deleteRoom(id: number) {
    this.rooms = this.rooms.filter(r => r.id !== id);
    if (this.editingRoom?.id === id) {
      this.editingRoom = null;
    }
    this.roomSrv.delete(id).subscribe({
      next: () => {
        this.roomForm.reset({ nightPrice: 0, capacity: 1, bedsSingle: 0, bedsDouble: 0 });
      },
      error: (err) => {
        console.error('Error al obtener habitaciones', err);
      }
    });
  }

  cancelEdit() {
    this.editingRoom = null;
    this.roomForm.reset({ nightPrice: 0, capacity: 1, bedsSingle: 0, bedsDouble: 0 });
  }
}
